module.exports = __webpack_public_path__ + "static/img/tabela.ce6f21f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/uva/tabela.png
// module id = YI+Q
// module chunks = 0